import { OrderEntity, OrderMissionEntity } from '@src/features/order/entities';

export const isMissionOrder = (order: OrderEntity | OrderMissionEntity | null): order is OrderMissionEntity => {
  return Boolean((order as OrderMissionEntity)?.missionId);
};